import { render, staticRenderFns } from "./custom-crm-newsletter.vue?vue&type=template&id=e52b8b88"
import script from "./custom-crm-newsletter.vue?vue&type=script&lang=js"
export * from "./custom-crm-newsletter.vue?vue&type=script&lang=js"
import style0 from "./custom-crm-newsletter.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports